<template>
    <div class="lightbox">
        <div class="back-drop" @click="$emit('close')"></div>
        <div class="lightbox-box">
            <span class="cursor-pointer lightbox-control lightbox-control-close"
                  @click="$emit('close')">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="20"
                     height="20"
                     viewBox="0 0 40 40">
                    <path style="stroke: currentColor; stroke-width: 5; stroke-linecap: round"
                          d="M 10,10 L 30,30 M 30,10 L 10,30"/>
                </svg>
            </span>
            <span class="cursor-pointer lightbox-control lightbox-control-left"
                  v-if="currentIndex > 0"
                  @click="previous()">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="25"
                     height="15"
                     style="transform: rotate(90deg)"
                     viewBox="0 0 10 6">
                    <path fill="currentColor"
                          d="M8.292893.292893c.390525-.390524 1.023689-.390524 1.414214 0 .390524.390525.390524 1.023689 0 1.414214l-4 4c-.390525.390524-1.023689.390524-1.414214 0l-4-4c-.390524-.390525-.390524-1.023689 0-1.414214.390525-.390524 1.023689-.390524 1.414214 0L5 3.585786 8.292893.292893z"></path>
                </svg>
            </span>
            <span class="cursor-pointer lightbox-control lightbox-control-right"
                  v-if="currentIndex < images.length - 1"
                  @click="next()">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="25"
                     height="15"
                     style="transform: rotate(-90deg)"
                     viewBox="0 0 10 6">
                    <path fill="currentColor"
                          d="M8.292893.292893c.390525-.390524 1.023689-.390524 1.414214 0 .390524.390525.390524 1.023689 0 1.414214l-4 4c-.390525.390524-1.023689.390524-1.414214 0l-4-4c-.390524-.390525-.390524-1.023689 0-1.414214.390525-.390524 1.023689-.390524 1.414214 0L5 3.585786 8.292893.292893z"></path>
                </svg>
            </span>
            <div class="image-container">
                <img class="lightbox-image" :src="currentImage">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Lightbox",
        props: ['images', 'index'],
        data() {
            return {
                currentIndex: this.index
            }
        },
        computed: {
            currentImage() {
                return this.images[this.currentIndex];
            }
        },
        methods: {
            previous() {
                this.currentIndex = Math.max(0, this.currentIndex - 1);
            },
            next() {
                this.currentIndex = Math.min(this.currentIndex + 1, this.images.length - 1);
            }
        }
    }
</script>

<style scoped lang="scss">
    .lightbox {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 11111;

        .back-drop {
            position: absolute;
            background-color: rgba(0, 0, 0, 0.6);
            width: 100%;
            height: 100%;
        }

        .lightbox-box {
            position: relative;
            background-color: white;
            width: 100vw;
            height: 100vh;

            @media (min-width: 768px) {
                width: 50vw;
                height: 50vh;
                margin-top: 25vh;
                margin-left: 25vw;
            }

            .lightbox-control {
                position: absolute;
                margin-top: -20px;
                top: 50%;
                color: black;

                &-close {
                    right: 5px;
                    top: 0;
                    margin-top: 0;
                }

                &-left {
                    left: 0;
                }

                &-right {
                    right: 0;
                }
            }

            .image-container {
                position: absolute;
                top: 25px;
                bottom: 25px;
                left: 25px;
                right: 25px;

                .lightbox-image {
                    position: absolute;
                    object-fit: contain;
                    object-position: center;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/Lightbox.vue